import { useSearchParams } from 'react-router-dom';
import { StatusSelectInput } from '../../tasks/components/status-select-input';
import {ProjectAutocompleteInput} from './project-autocomplete-input';
import DataTableFilters, {
  DataTableFiltersProps,
} from '@/components/refinedev/data-table/data-table-filters';

type ProjectFiltersProps = Pick<DataTableFiltersProps, 'table'>;

const ProjectFilters: React.FC<ProjectFiltersProps> = ({table}) => {
  return (
    <DataTableFilters
      table={table}
      defaultValues={{
        status: null,
      }}
      className="w-[500px]"
      transformFilter={data => {
        const filters: any[] = [];
        // Filter by status
        if (data.status) {
          filters.push({
            field: 'status',
            operator: 'eq',
            value: data.status,
          });
        }

        return filters;
      }}
      showAs="collapsible"
      autoApply={true}
      closeWhenApply={false}
      // closeWhenApply={false}
      // asPopover={false}
    >
      <div className="flex space-x-1 items-center">
        <StatusSelectInput source="status" label=''/>
      </div>
    </DataTableFilters>
  );
};

export default ProjectFilters;
